// Social Video #1 - Video Control with enhanced pause functionality
function tptSocialPauseAllVideo() {
	document.querySelectorAll('.tpt-social-video-main').forEach((video) => video.pause());
}

function tptSocialMutedAllVideo() {
	document.querySelectorAll('.tpt-social-video-main').forEach((video) => (video.muted = true));
}

if (!customElements.get('tpt-social-video-item')) {
	customElements.define(
		'tpt-social-video-item',
		class TptSocialVideoItem extends HTMLElement {
			constructor() {
				super();

				this.playBtn = this.querySelector('tpt-social-play-video');
				this.pauseBtn = this.querySelector('tpt-social-pause-video');
				this.videoContainer = this.querySelector('.social-video-1_video');
				
				if (this.playBtn) {
					this.playBtn.addEventListener('click', this.playVideo.bind(this));
				}
				
				if (this.pauseBtn) {
					this.pauseBtn.addEventListener('click', this.pauseVideo.bind(this));
				}

				// Add click event to video container for play/pause toggle
				if (this.videoContainer) {
					this.videoContainer.addEventListener('click', (e) => {
						// Check if click is on pause button or play button
						if (e.target.closest('tpt-social-pause-video') || e.target.closest('tpt-social-play-video')) {
							return; // Let the button handle the click
						}
						
						// Toggle play/pause when clicking on video area
						if (this.classList.contains('loaded')) {
							this.pauseVideo();
						} else {
							this.playVideo();
						}
					});
				}
			}

			playVideo() {
				// If video is already playing, pause it
				if (this.classList.contains('loaded')) {
					this.pauseVideo();
					return;
				}

				tptSocialMutedAllVideo();

				document.querySelectorAll('tpt-social-play-video').forEach((playBtn) => {
					playBtn.classList.remove('active');
				});

				/**
				 * Pause all videos if only one video mode is enabled
				 */
				if (this.closest('tpt-social-group-video[data-only-one-video="true"]')) {
					this.closest('tpt-social-group-video')
						.querySelectorAll('.tpt-social-video-main')
						.forEach((video) => video.pause());
				}

				/**
				 * Set all video items to default state
				 */
				document.querySelectorAll('tpt-social-video-item').forEach((item) => {
					item.classList.remove('loaded');

					const videoMain = item.querySelector('.tpt-social-video-main');
					if (videoMain) {
						videoMain.classList.remove('active');
						videoMain.pause();
					}
				});

				/**
				 * Activate current video item
				 */
				this.classList.add('loaded');
				const mainVideo = this.querySelector('.tpt-social-video-main');
				if (mainVideo) {
					mainVideo.classList.add('active');
					mainVideo.play();
					mainVideo.muted = false;
				}

				if (this.playBtn) {
					this.playBtn.classList.add('active');
				}

				/**
				 * Handle other sections when not in one-video mode
				 */
				if (!this.closest('tpt-social-group-video[data-only-one-video="true"]')) {
					const groupVideoOneTime = document.querySelectorAll('tpt-social-group-video[data-only-one-video="true"]');

					if (groupVideoOneTime) {
						groupVideoOneTime.forEach((group) => {
							const itemVideos = group.querySelectorAll('tpt-social-video-item');

							itemVideos.forEach((item) => {
								const videos = item.querySelectorAll('.tpt-social-video-main');

								if (videos.length >= 1) {
									videos[0].play();
									videos[0].muted = true;
								}
							});
						});
					}
				}
			}

			pauseVideo() {
				const mainVideo = this.querySelector('.tpt-social-video-main');
				if (mainVideo) {
					mainVideo.classList.remove('active');
					mainVideo.pause();
					mainVideo.muted = true;
				}

				if (this.playBtn) {
					this.playBtn.classList.remove('active');
				}
				
				this.classList.remove('loaded');
			}
		}
	);
}

if (!customElements.get('tpt-social-play-video')) {
	customElements.define(
		'tpt-social-play-video',
		class TptSocialPlayVideo extends HTMLElement {
			constructor() {
				super();
				
				// Make element focusable for accessibility
				this.setAttribute('tabindex', '0');
				this.setAttribute('role', 'button');
				this.setAttribute('aria-label', 'Play video');
				
				// Handle keyboard events
				this.addEventListener('keydown', (e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						this.click();
					}
				});
			}
		}
	);
}

if (!customElements.get('tpt-social-pause-video')) {
	customElements.define(
		'tpt-social-pause-video',
		class TptSocialPauseVideo extends HTMLElement {
			constructor() {
				super();
				
				// Make element focusable for accessibility
				this.setAttribute('tabindex', '0');
				this.setAttribute('role', 'button');
				this.setAttribute('aria-label', 'Pause video');
				
				// Handle keyboard events
				this.addEventListener('keydown', (e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						this.click();
					}
				});
			}
		}
	);
}

if (!customElements.get('tpt-social-group-video')) {
	customElements.define(
		'tpt-social-group-video',
		class TptSocialGroupVideo extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				// Initialize video states when connected
				this.initializeVideos();
			}

			initializeVideos() {
				const videoItems = this.querySelectorAll('tpt-social-video-item');
				
				videoItems.forEach((item) => {
					const video = item.querySelector('.tpt-social-video-main');
					if (video) {
						// Set up video event listeners
						this.setupVideoEvents(video, item);
					}
				});
			}

			setupVideoEvents(video, videoItem) {
				// Handle video errors
				video.addEventListener('error', (e) => {
					console.warn('Social video failed to load:', e);
					videoItem.style.opacity = '0.5';
				});

				// Prevent video controls
				video.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopPropagation();
				});

				// Disable context menu
				video.addEventListener('contextmenu', (e) => {
					e.preventDefault();
				});

				// Handle video ended
				video.addEventListener('ended', () => {
					videoItem.classList.remove('loaded');
					const playBtn = videoItem.querySelector('tpt-social-play-video');
					if (playBtn) {
						playBtn.classList.remove('active');
					}
					video.currentTime = 0;
				});

				// Handle video loading
				video.addEventListener('loadeddata', () => {
					videoItem.style.opacity = '1';
				});

				// Handle video pause
				video.addEventListener('pause', () => {
					if (videoItem.classList.contains('loaded')) {
						// Video was paused, update states
						videoItem.classList.remove('loaded');
						const playBtn = videoItem.querySelector('tpt-social-play-video');
						if (playBtn) {
							playBtn.classList.remove('active');
						}
					}
				});

				// Handle video play
				video.addEventListener('play', () => {
					if (!videoItem.classList.contains('loaded')) {
						videoItem.classList.add('loaded');
						const playBtn = videoItem.querySelector('tpt-social-play-video');
						if (playBtn) {
							playBtn.classList.add('active');
						}
					}
				});
			}
		}
	);
}

// Global cleanup functions
window.tptSocialPauseAllVideo = tptSocialPauseAllVideo;
window.tptSocialMutedAllVideo = tptSocialMutedAllVideo;

// Handle page visibility changes
document.addEventListener('visibilitychange', () => {
	if (document.hidden) {
		// Pause all videos when page becomes hidden
		tptSocialPauseAllVideo();
	}
});

// Handle Shopify theme editor
if (window.Shopify && window.Shopify.designMode) {
	document.addEventListener('shopify:section:load', () => {
		// Re-initialize custom elements when sections are loaded in theme editor
		setTimeout(() => {
			const socialGroups = document.querySelectorAll('tpt-social-group-video');
			socialGroups.forEach(group => {
				if (group.initializeVideos) {
					group.initializeVideos();
				}
			});
		}, 100);
	});

	document.addEventListener('shopify:section:unload', () => {
		// Pause all videos when section is unloaded
		tptSocialPauseAllVideo();
	});

	document.addEventListener('shopify:section:select', () => {
		// Pause all videos when another section is selected
		tptSocialPauseAllVideo();
	});
}